import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';

import { AuthService } from './../../shared/services/auth.service';
import { LevelingService } from './../../shared/services/leveling.service';

import * as moment from 'moment';

import { ToastrService } from 'ngx-toastr';
import { Router, ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-leveling-layout',
  templateUrl: './leveling-layout.component.html',
  styleUrls: ['./leveling-layout.component.scss']
})
export class LevelingLayoutComponent implements OnInit {    

  public firstForm: FormGroup;
  public levelingForm: FormGroup;
  public completeRegisterForm: FormGroup;
  public bsInlineValue = new Date();
  public selectedDate: string;
  public seletectedHourId: number;
  public isStudiedEnglish: string;
  public submittingHour: boolean = false;
  public submittingScheduler: boolean = false;
  public isSchedulerOk: boolean = false;
  public returnMessage: string;
  public messagesErrors: any[] = [];
  public hours: Array<any> = [];
  public isOk: boolean = false;
  public key: string;
  public isEditable: boolean = true;

  
  constructor(
    private formBuilder: FormBuilder,
    private levelingService: LevelingService,
    private toastr: ToastrService,
    private router: Router,
    private route: ActivatedRoute,
    private authService: AuthService
  ) { }

  ngOnInit() {
    this.bsInlineValue = new Date();
    this.route.queryParams.subscribe((params: any) => {
    
      if (!params.hasOwnProperty('key')) {
        this.redirectRegister();
        return;
      }
      
      this.key = params.key;
      this.authService.verifyKey(params.key).subscribe((key: string) => {
        console.log('verified');
           
        this.isOk = true;
      }, () => {
        this.redirectRegister();
        return;
      });
    })

    this.buildFirstForm();
    this.buildLevelingForm();
  }

  public onSubmittedStudiedEnglish() {
    this.isStudiedEnglish = this.firstForm.get('studiedEnglish').value;

    if (this.isStudiedEnglish === 'S')
      this.loadingHours();
    else 
      this.redirect();
    
  }

  public onSubmittedScheduler() {
    if (this.levelingForm.valid) {
      this.submittingScheduler = true;
      this.isSchedulerOk = false;

      this.levelingService.insert(this.levelingForm.value).subscribe((data: string) => {        
        this.toastr.success(data, null, {
          timeOut: 2000,
          positionClass: 'toast-bottom-center',
          progressAnimation: 'decreasing',
          closeButton: true
        });
        this.returnMessage = data;
        this.submittingScheduler = false;
        this.isSchedulerOk = true;
        this.isEditable = false;
      }, (error: any) => {
        this.seletectedHourId = null;
        this.levelingForm.get("hourId").setValue(null);
        this.returnMessage = error.message;
        this.messagesErrors = error.errors;
        this.isSchedulerOk = false;
        this.submittingScheduler = false;
      });
    }
  }

  public onValueChange(value?: Date): void {
    this.selectedDate =  value ? moment(value, 'YYYY-MM-DD').format('DD/MM/YYYY') : this.selectedDate ? this.selectedDate : moment().format('DD/MM/YYYY') ;

    if (this.isOk)
      this.loadingHours();
  }

  public onValueHourId(hour: any): void {
    if (hour.vacancy === 'S' && hour.id) {
      this.seletectedHourId = hour.id;
      this.levelingForm.get("hourId").setValue(hour.id);
      this.levelingForm.get("studiedEnglish").setValue(this.isStudiedEnglish);
    } else {
      this.toastr.warning(hour.txtVacancy, null, {
        timeOut: 2000,
        positionClass: 'toast-bottom-center',
        progressAnimation: 'decreasing',
        closeButton: true
      });
    }
  }


  public redirect() {
    this.router.navigateByUrl('/', { skipLocationChange: true })
    .then(() => {
      this.router.navigate(['/complete-register'], { queryParams: { key: this.key} });
    }); 
  }

  // METHODS PRIVATES
  // BUILDS FORMS   
  private buildFirstForm() {
    this.firstForm = this.formBuilder.group({
      studiedEnglish: this.formBuilder.control("", Validators.required)
    });
  }

  private buildLevelingForm() {
    this.levelingForm = this.formBuilder.group({
      studiedEnglish: this.formBuilder.control('', Validators.required),
      studiedWhere: this.formBuilder.control('', Validators.required),
      studiedTime: this.formBuilder.control('', Validators.required),
      timeWithoutStudying: this.formBuilder.control('', Validators.required),
      modalityId: this.formBuilder.control('', Validators.required),
      hourId: this.formBuilder.control('', Validators.required),      
    });
  }

  private loadingHours() {
    this.submittingHour = true;
    this.levelingService.findGuestHoursByDate(this.selectedDate, this.selectedDate).subscribe((el: any) => {
      this.submittingHour = false;
      this.hours = el.hours;
    }, () => {
      this.submittingHour = false;
    });
  }

  private redirectRegister() {
    this.router.navigateByUrl('/', { skipLocationChange: true })
    .then(() => {
      this.router.navigate(['/register']);        
      return;          
    });
  }
}
